import React from 'react'
import { useSelector } from 'react-redux'

import StreamCard from '../Cards/StreamCard'
import { StreamState, Stream } from '../../../../../types';
import HomepageSection from '../HomepageSection';

import { DatabaseStreamState } from '../../../../../types';


export default function DatabaseStreams() {

    const state = useSelector((state: DatabaseStreamState) => state.databaseStreams)

    const CardsRendered = state.map( card => <StreamCard props={card}/>)
    return <HomepageSection>{CardsRendered}</HomepageSection>;
}
